import { externalLinkGA } from '../analytics';

export const A = ({ href, onClick, className, title = '', children }) => {
  const handleClick = () => {
    onClick?.();
    externalLinkGA(href);
  };
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className} title={title} onClick={handleClick}>
      {children}
    </a>
  );
};
